import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';
import { InMessageEmailCustomization } from './models';

@Injectable({
  providedIn: 'root',
})
export class InMessageEmailCustomizationService {
  constructor(
    private alcmeonContextService: AlcmeonContextService,
    private errorHandlingService: ErrorHandlingService,
    private http: HttpClient
  ) {}

  getCustomization(siteId: number): Observable<InMessageEmailCustomization> {
    return this.http
      .get<InMessageEmailCustomization>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/sites/${siteId}/email-customization`
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  createCustomization(siteId: number, data: InMessageEmailCustomization): Observable<InMessageEmailCustomization> {
    return this.http
      .post<InMessageEmailCustomization>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/sites/${siteId}/email-customization`,
        data
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  updateCustomization(siteId: number, data: InMessageEmailCustomization): Observable<InMessageEmailCustomization> {
    return this.http
      .put<InMessageEmailCustomization>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/sites/${siteId}/email-customization`,
        data
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }
}
